import Topbar from "../../components/Topbar";
import { useState } from "react";
import { useVendas } from "./hooks/useVendas";
import { STATUS, STATUS_KEYS, MESES } from "./constants";
import { filtrarPorMes, fmt } from "./utils";
import TabelaPedidos from "./components/TabelaPedidos";
import ModalPedido from "./components/ModalPedido";
import ModalRetirada from "./components/ModalRetirada";

const mesAtual = new Date().getMonth();
const anoAtual = new Date().getFullYear();

export default function Vendas() {
  const [mes, setMes]                   = useState(mesAtual);
  const [ano, setAno]                   = useState(anoAtual);
  const [busca, setBusca]               = useState("");
  const [filtroStatus, setFiltroStatus] = useState("");

  const {
    pedidos, clientes, produtos, loading, salvando,
    form, itens, modalForm, modalRetirada,
    setF, setItem, selectProduto, addItem, removeItem,
    abrirNovo, abrirEditar, fecharModal,
    salvar, excluir, mudarStatus,
    abrirRetirada, registrarRetirada, setModalRetirada, carregar,
  } = useVendas();

  const pedidosDoMes = filtrarPorMes(pedidos, mes, ano);
  const pedidosFiltrados = pedidosDoMes
    .filter(p => !filtroStatus || p.status === filtroStatus)
    .filter(p =>
      (p.cliente_nome || "").toLowerCase().includes(busca.toLowerCase()) ||
      String(p.id).includes(busca)
    );

  const totalMes     = pedidosFiltrados.reduce((s, p) => s + parseFloat(p.valor_total || 0), 0);
  const contarStatus = s => pedidosDoMes.filter(p => p.status === s).length;
  const irMesAnterior = () => { if (mes === 0) { setMes(11); setAno(a => a - 1); } else setMes(m => m - 1); };
  const irProximoMes  = () => { if (mes === 11) { setMes(0); setAno(a => a + 1); } else setMes(m => m + 1); };

  return (
    <>
      <Topbar title="Vendas" />
      <div className="erp-content">
        <div className="page-toolbar">
          <button className="btn btn-primary" onClick={abrirNovo}>
            <i className="ti ti-plus" /> Novo pedido
          </button>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <button className="btn btn-secondary" style={{ padding: "4px 8px" }} onClick={irMesAnterior}>‹</button>
            <strong style={{ fontSize: 13, minWidth: 140, textAlign: "center" }}>{MESES[mes]} {ano}</strong>
            <button className="btn btn-secondary" style={{ padding: "4px 8px" }} onClick={irProximoMes}>›</button>
          </div>
          <input className="form-input" style={{ width: 220 }} placeholder="Buscar cliente ou #..."
            value={busca} onChange={e => setBusca(e.target.value)} />
        </div>
        <div style={{ display: "flex", marginBottom: 12, alignItems: "center" }}>
          <div style={{ marginLeft: "auto", fontSize: 13, fontWeight: 700, color: "var(--z-blue)" }}>
            Total do mes: R$ {fmt(totalMes)}
          </div>
        </div>
        <div className="card">
          <div className="table-wrapper">
            {loading ? <div className="table-empty">Carregando...</div> : (
              <TabelaPedidos pedidos={pedidosFiltrados} onEditar={abrirEditar}
                onExcluir={excluir} onMudarStatus={mudarStatus} onAbrirRetirada={abrirRetirada}
                onRecarregar={carregar} mes={mes} ano={ano} meses={MESES} />
            )}
          </div>
        </div>
      </div>
      <ModalPedido modalForm={modalForm} form={form} itens={itens}
        clientes={clientes} produtos={produtos} salvando={salvando}
        setF={setF} setItem={setItem} selectProduto={selectProduto}
        addItem={addItem} removeItem={removeItem} onSalvar={salvar} onFechar={fecharModal} />
      <ModalRetirada pedido={modalRetirada} onConfirmar={registrarRetirada}
        onFechar={() => setModalRetirada(null)} />
    </>
  );
}



